<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">sell</mat-icon>
  </div>
  <div class="modal-header-titles">
    <span class="formacao-precos-eyebrow">Formação de preços</span>
    <h2 class="modal-title">{{ titulo }}</h2>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn icon-mat-symbols-btn" aria-label="Fechar" (click)="cancelar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content formacao-precos-content">
  @if (isLoading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  } @else if (erroCarregamento) {
  <app-alert-card type="error" title="Formação de preços indisponível">
    {{ erroCarregamento }}
    <div alertActions>
      <button mat-stroked-button type="button" class="btn-secondary" (click)="carregar()">
        <mat-icon class="material-symbols-outlined">refresh</mat-icon>
        Tentar novamente
      </button>
    </div>
  </app-alert-card>
  } @else if (resolucao) {
  <div class="formacao-precos-progresso">
    @if (isCalculando) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </div>

  <mat-tab-group class="formacao-precos-tabs" appTabsScroll [mat-stretch-tabs]="false" [disablePagination]="true">

    <!-- Aba 1: Preços de custos -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="material-symbols-outlined tab-icon">paid</mat-icon>
        <span class="tab-label-text">Preços de custos</span>
      </ng-template>

      <div class="aba-conteudo">
        <div class="formacao-precos-cards">
          <div class="sub-section-container">
            <div class="sub-section-title">
              <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
              <span>Impostos da nota fiscal</span>
            </div>
            <div class="impostos-nota">
              <div class="imposto-nota-linha">
                <span class="imposto-nota-rotulo"><b>(+)</b> Frete</span>
                <mat-form-field appearance="outline" class="imposto-nota-campo" subscriptSizing="dynamic">
                  <input matInput type="text" inputmode="decimal" [currencyMask]="currencyMask"
                    [(ngModel)]="valorFrete" (ngModelChange)="agendarRecalculo()" aria-label="Frete"
                    matTooltip="Frete rateado entre os itens pelo valor de cada item">
                </mat-form-field>
              </div>
              <div class="imposto-nota-linha">
                <span class="imposto-nota-rotulo"><b>(+)</b> Seguro</span>
                <span class="imposto-nota-valor">{{ resolucao.totais.valorSeguro | abnt: 'preco': 2 }}</span>
              </div>
              <div class="imposto-nota-linha">
                <span class="imposto-nota-rotulo"><b>(+)</b> Despesas</span>
                <span class="imposto-nota-valor">{{ resolucao.totais.valorOutrasDespesas | abnt: 'preco': 2 }}</span>
              </div>
              <div class="imposto-nota-linha">
                <span class="imposto-nota-rotulo"><b>(+)</b> IPI</span>
                <span class="imposto-nota-valor">{{ resolucao.totais.valorIpi | abnt: 'preco': 2 }}</span>
              </div>
              <div class="imposto-nota-linha">
                <span class="imposto-nota-rotulo"><b>(+)</b> ICMS ST</span>
                <span class="imposto-nota-valor">{{ resolucao.totais.valorIcmsSt | abnt: 'preco': 2 }}</span>
              </div>
              <div class="imposto-nota-linha">
                <span class="imposto-nota-rotulo"><b>(+)</b> FCP ST</span>
                <span class="imposto-nota-valor">{{ resolucao.totais.valorFcpSt | abnt: 'preco': 2 }}</span>
              </div>
              <div class="imposto-nota-linha imposto-nota-credito">
                <span class="imposto-nota-rotulo"><b>(−)</b> Desconto</span>
                <span class="imposto-nota-valor">{{ resolucao.totais.valorDesconto | abnt: 'preco': 2 }}</span>
              </div>
              <div class="imposto-nota-linha imposto-nota-credito imposto-nota-destaque">
                <span class="imposto-nota-rotulo"><b>(−)</b> Impostos recuperáveis</span>
                <span class="imposto-nota-valor">{{ previa?.valorImpostosRecuperaveis || 0 | abnt: 'preco': 2 }}</span>
              </div>
            </div>
          </div>

          <div class="sub-section-container">
            <div class="sub-section-title">
              <mat-icon class="material-symbols-outlined">savings</mat-icon>
              <span>Impostos recuperáveis</span>
            </div>
            <p class="sub-section-sub-title">Creditados na entrada, saem do custo dos itens.</p>
            <div class="impostos-recuperaveis">
              @for (imposto of resolucao.impostosRecuperaveis; track imposto.idImpostoRecuperavel) {
              <span [matTooltip]="motivoImpostoDesabilitado(imposto)">
                <button type="button" class="status-badge status-badge-selecionavel"
                  [class.is-selecionado]="isImpostoSelecionado(imposto)"
                  [disabled]="!!motivoImpostoDesabilitado(imposto)"
                  [attr.aria-pressed]="isImpostoSelecionado(imposto)"
                  (click)="alternarImposto(imposto)">
                  <span class="badge-check">
                    @if (isImpostoSelecionado(imposto)) {
                    <mat-icon class="material-symbols-outlined">check</mat-icon>
                    }
                  </span>
                  {{ imposto.descricao }}
                </button>
              </span>
              }
            </div>
            <app-alert-card type="success" icon="savings">
              Crédito total: <b>{{ previa?.valorImpostosRecuperaveis || 0 | abnt: 'preco': 2 }}</b> - abatido do custo dos itens.
            </app-alert-card>
          </div>
        </div>

        <div class="table-container">
          <table mat-table [dataSource]="linhas">
            <ng-container matColumnDef="selecao">
              <th mat-header-cell *matHeaderCellDef class="w-checkbox">
                <mat-checkbox [checked]="isTodosSelecionados" [indeterminate]="isSelecaoParcial" (change)="alternarTodos()"
                  aria-label="Selecionar todos os itens"></mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let linha" class="w-checkbox">
                <mat-checkbox [(ngModel)]="linha.isSelecionado" [attr.aria-label]="'Selecionar item ' + linha.item.numeroItem"></mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="item">
              <th mat-header-cell *matHeaderCellDef>Item</th>
              <td mat-cell *matCellDef="let linha">
                <span class="item-descricao" [matTooltip]="linha.item.descricao">{{ linha.item.descricao }}</span>
                <span class="item-detalhe">
                  forn {{ linha.item.codigoProdutoEmitente || '-' }} · int {{ linha.item.codigoSku || '-' }} ·
                  custo atual {{ linha.item.valorCustoAtual | abnt: 'preco': 2 }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="precoUnitarioCompra">
              <th mat-header-cell *matHeaderCellDef class="text-end">Preço unit. compra</th>
              <td mat-cell *matCellDef="let linha" class="text-end valor-secundario">
                {{ linha.item.valorUnitarioCompra | abnt: 'preco': 2 }}
                <span class="item-unidade">/ {{ linha.item.unidadeEstoque || 'un' }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="difal">
              <th mat-header-cell *matHeaderCellDef class="text-end">(+) DIFAL compra</th>
              <td mat-cell *matCellDef="let linha" class="text-end">
                <mat-form-field appearance="outline" class="campo-tabela" subscriptSizing="dynamic">
                  <input matInput type="text" inputmode="decimal" [currencyMask]="currencyMask"
                    [(ngModel)]="linha.valorDifal" (ngModelChange)="agendarRecalculo()"
                    [attr.aria-label]="'DIFAL do item ' + linha.item.numeroItem">
                </mat-form-field>
              </td>
            </ng-container>

            <ng-container matColumnDef="precoCusto">
              <th mat-header-cell *matHeaderCellDef class="text-end">Preço custo compra</th>
              <td mat-cell *matCellDef="let linha" class="text-end valor-principal">
                <span [class.valor-pendente]="isPreviaPendente">{{ linha.resultado?.valorPrecoCusto || 0 | abnt: 'preco': 2 }}</span>
                <button mat-icon-button type="button" class="icon-mat-symbols-btn botao-memoria" [disabled]="!linha.resultado"
                  matTooltip="Ver como o custo foi calculado" (click)="abrirMemoriaCalculo(linha)"
                  [attr.aria-label]="'Memória de cálculo do item ' + linha.item.numeroItem">
                  <mat-icon class="material-symbols-outlined">info</mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="custoMedio">
              <th mat-header-cell *matHeaderCellDef class="text-end"
                [matTooltip]="resolucao?.isEstoqueLancado ? 'Custo médio atual do produto, que já contém esta nota.' : 'Custo médio do produto depois desta nota, projetado item a item.'">
                Preço custo médio</th>
              <td mat-cell *matCellDef="let linha" class="text-end valor-secundario">
                <span [class.valor-pendente]="isPreviaPendente">{{ linha.resultado?.valorCustoMedio || 0 | abnt: 'preco': 2 }}</span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="colunasCusto"></tr>
            <tr mat-row *matRowDef="let row; columns: colunasCusto"></tr>
          </table>
        </div>
      </div>
    </mat-tab>

    <!-- Aba 2: Preços de venda -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="material-symbols-outlined tab-icon">storefront</mat-icon>
        <span class="tab-label-text">Preços de venda</span>
      </ng-template>

      <div class="aba-conteudo">
        <app-alert-card type="info">
          Editar o markup recalcula o preço de venda; editar o preço de venda recalcula o markup implícito.
          A base de custo segue o seletor abaixo.
        </app-alert-card>

        <div class="venda-controles">
          <div class="venda-controle">
            <span class="venda-controle-rotulo">Formar preço com base em</span>
            <span [matTooltip]="motivoBaseDesabilitada">
              <mat-button-toggle-group class="btn-toggle-group" [value]="idTipoBasePrecoVenda"
                [disabled]="resolucao.isFormulaPrecoVendaPersonalizada" (change)="alterarBase($event.value)">
                <mat-button-toggle [value]="TipoBasePrecoVendaEnum.PrecoCustoCompra">Preço de custo da compra</mat-button-toggle>
                <mat-button-toggle [value]="TipoBasePrecoVendaEnum.CustoMedio">Preço de custo médio</mat-button-toggle>
              </mat-button-toggle-group>
            </span>
          </div>
          <div class="venda-controle venda-controle-markup">
            <mat-form-field appearance="outline" class="campo-markup-geral" subscriptSizing="dynamic">
              <mat-label>Markup geral</mat-label>
              <input matInput type="text" inputmode="decimal" [currencyMask]="decimalMask" [(ngModel)]="markupGeral">
              <span matTextSuffix>%</span>
            </mat-form-field>
            <button mat-button type="button" class="btn-link" [disabled]="markupGeral === null" (click)="aplicarMarkupATodos()">
              Aplicar a todos
            </button>
          </div>
        </div>

        <div class="table-container">
          <table mat-table [dataSource]="linhas">
            <ng-container matColumnDef="item">
              <th mat-header-cell *matHeaderCellDef>Item</th>
              <td mat-cell *matCellDef="let linha">
                <span class="item-descricao" [matTooltip]="linha.item.descricao">{{ linha.item.descricao }}</span>
                <span class="item-detalhe">int {{ linha.item.codigoSku || '-' }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="custoNovo">
              <th mat-header-cell *matHeaderCellDef class="text-end">Custo novo</th>
              <td mat-cell *matCellDef="let linha" class="text-end valor-secundario">
                <span [class.valor-pendente]="isPreviaPendente">{{ custoBase(linha) | abnt: 'preco': 2 }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="markup">
              <th mat-header-cell *matHeaderCellDef class="text-end">Markup %</th>
              <td mat-cell *matCellDef="let linha" class="text-end">
                <mat-form-field appearance="outline" class="campo-tabela campo-markup" subscriptSizing="dynamic">
                  <input matInput type="text" inputmode="decimal" [currencyMask]="decimalMask"
                    [(ngModel)]="linha.percentualMarkup" (ngModelChange)="alterarMarkup(linha)"
                    [attr.aria-label]="'Markup do item ' + linha.item.numeroItem">
                  <span matTextSuffix>%</span>
                </mat-form-field>
              </td>
            </ng-container>

            <ng-container matColumnDef="precoVenda">
              <th mat-header-cell *matHeaderCellDef class="text-end">Preço de venda</th>
              <td mat-cell *matCellDef="let linha" class="text-end">
                <span [matTooltip]="resolucao.isFormulaPrecoVendaPersonalizada
                  ? 'Com a fórmula de venda personalizada, ajuste o markup para mudar o preço.' : ''">
                  <mat-form-field appearance="outline" class="campo-tabela campo-preco-venda" subscriptSizing="dynamic">
                    <input matInput type="text" inputmode="decimal" [currencyMask]="currencyMask"
                      [ngModel]="precoExibido(linha)" (ngModelChange)="alterarPreco(linha, $event)"
                      (blur)="encerrarEdicaoPreco(linha)" [disabled]="resolucao.isFormulaPrecoVendaPersonalizada"
                      [attr.aria-label]="'Preço de venda do item ' + linha.item.numeroItem">
                  </mat-form-field>
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="precoAtual">
              <th mat-header-cell *matHeaderCellDef class="text-end">Preço atual</th>
              <td mat-cell *matCellDef="let linha" class="text-end valor-secundario">
                {{ linha.item.valorPrecoVendaAtual | abnt: 'preco': 2 }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="colunasVenda"></tr>
            <tr mat-row *matRowDef="let row; columns: colunasVenda"></tr>
          </table>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
  }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer formacao-precos-footer">
  @if (resolucao) {
  <div class="formacao-precos-opcoes">
    <mat-slide-toggle [(ngModel)]="isAtualizarCusto">Atualizar o custo dos produtos</mat-slide-toggle>
    <span [matTooltip]="motivoPrecoVendaDesabilitado">
      <mat-slide-toggle [(ngModel)]="isAtualizarPrecoVenda" [disabled]="!resolucao.isListaPrecoPadraoManual">
        Atualizar o preço de venda dos produtos
      </mat-slide-toggle>
    </span>
    <mat-slide-toggle [(ngModel)]="isAtualizarMarkup">Atualizar markup de venda dos produtos</mat-slide-toggle>
  </div>
  }
  <div class="formacao-precos-botoes">
    <button mat-stroked-button type="button" class="btn-secondary" (click)="cancelar()">Cancelar</button>
    <span [matTooltip]="motivoAtualizarDesabilitado">
      <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="isAplicando"
        [disabled]="!resolucao || !!motivoAtualizarDesabilitado || isPreviaPendente || isCalculando || isAplicando"
        [attr.aria-label]="isAplicando ? 'Atualizando preços' : 'Atualizar preços'" (click)="atualizarPrecos()">
        <mat-icon class="material-symbols-outlined">check</mat-icon>
        Atualizar preços
        @if (isAplicando) { <mat-spinner diameter="20"></mat-spinner> }
      </button>
    </span>
  </div>
</mat-dialog-actions>
